import endpoints from '@app/src/api/endpoints'
import { FetchKey, useFetchResource } from '@app/src/api/fetchHooks'
import { useUpdateResource } from '@app/src/api/updateHooks'
import type { EntitlementPolicy } from '@app/src/types/entitlements'
import { useQueryClient } from '@tanstack/react-query'

export const useEntitlementPolicies = (enabled = true) => {
  const {
    data: policies = [],
    isLoading,
    isError,
  } = useFetchResource<EntitlementPolicy[]>({
    key: [FetchKey.EntitlementPolicies],
    endpoint: endpoints.entitlementPolicies,
    options: { enabled },
  })

  return { policies, isLoading, isError }
}

export const useSaveEntitlementPolicies = () => {
  const queryClient = useQueryClient()
  const { mutateAsync, isPending: isSaving } = useUpdateResource<unknown, EntitlementPolicy[]>()

  const savePolicies = async (changes: EntitlementPolicy[]) => {
    if (changes.length === 0) return

    await mutateAsync({ url: endpoints.entitlementPolicies, body: changes })
    queryClient.invalidateQueries({ queryKey: [FetchKey.EntitlementPolicies] })
    queryClient.invalidateQueries({ queryKey: [FetchKey.OrganizationEntitlements] })
  }

  return { savePolicies, isSaving }
}
